export const formatReportCount = (count: number): string =>
  count > 10000
    ? `${(count / 1000).toFixed()}k`
    : count.toLocaleString('en-US');

export const formatStatsCount = (count: number): string =>
  count > 10000 ? `${(count / 1000).toFixed()}k` : count.toString();
